(function(){
    angular.module('tmx-app').controller('dynamicFormCtrl',['dynamicFormService','resolvedData','LoanApplicationService','tmxUtility',dynamicFormCtrl]);
    var exists;
    var copy;
    function dynamicFormCtrl(df,resolvedData,las,tmxUtility){
        var vm=this;
        exists=tmxUtility.exists;
        copy=tmxUtility.copy;
        if(exists(resolvedData,"pageSchema.data")){
            vm.pageSchema=resolvedData.pageSchema.data;
            vm.pageSchema=Page;
            vm.page=df.loadPage(vm.pageSchema);
            vm.page.config.cols=2;
            if(exists(resolvedData,"loanApplicationData.data")&&false){
                vm.loanApplicationData=resolvedData.loanApplicationData.data;
                wrapLoanApplicationAttributes(vm.loanApplicationData);
                vm.page.read(vm.loanApplicationData);
                vm.commands=vm.loanApplicationData.Commands;
                vm.commands.forEach(function(command){command.label=formatName(command.VisibleValue)});
            }
            else{
                vm.loanApplicationData=new las();
            }
        }

        vm.resource= new las();

        vm.submit=function(){
            if(exists(vm.page)){
                vm.page.write(vm.resource);
                unwrapLoanApplicationAttributes(vm.resource);
				// fix for TmxCustomerHousehold not implimented at back end
                delete vm.resource.TmxCustomerHousehold;
				// fix for LoanApplicationNumber must be given in during update
                if(exists(vm.loanApplicationData))
                    copy(vm.loanApplicationData,["LoanApplicationId","LoanApplicationNumber"],vm.resource);
                else{
                    vm.resource.LoanApplicationNumber = 0;
                }
                vm.resource.$saveOrUpdate();
            }
        }

        vm.reset=function(){
            if(exists(vm.page) && exists(vm.loanApplicationData)){
                vm.page.read(vm.loanApplicationData);
            }
        }

        vm.callback="private.inbox";
        vm.submitCommand=function(command){
            function gotocallback(){
	          vm.goto(vm.callback);
	        }
	        var action="action/"+vm.loanApplicationData.LoanApplicationId+"/"+command;
	        copy(vm.loanApplicationData,["LoanApplicationId","LoanApplicationNumber"],vm.resource);
	        vm.resource.getByAction(action,false,"put").then(gotocallback);
	    }


    }


    function formatName(name){
    	var arr=name.split(/(?=[A-Z])/);
        var result="";
        arr.forEach(function(token,index){
            result+=token;
            if(index<arr.length-1){
                result+=" ";
            }
        });
        return result;
    }

    function wrapLoanApplicationAttributes(resource){
        resource.TmXAccountApplication=[{
            "TenantId": resource.TenantId,
		    "CompanyBranchId": resource.CompanyBranchId,
		    "LoanProductId": resource.ProductId,
		    "LoanApplicationId": resource.LoanApplicationId,
		    "LoanApplicationNumber": resource.LoanApplicationNumber,
		    "ClientReferenceNumber": resource.ClientReferenceNumber,
		    "LoanApplicationDate": resource.LoanApplicationDate,
		    "CustomerHouseholdId": resource.CustomerHouseholdId,
		    "RequestedLoanAmount": resource.RequestedLoanAmount,
		    "ApprovedLoanAmount": resource.ApprovedLoanAmount,
		    "TotalRecieiveableAmount": resource.TotalRecieiveableAmount,
		    "LoanDisbursementDate": resource.LoanDisbursementDate,
		    "LoanMaturityDate": resource.LoanMaturityDate,
		    "TotalInstallments": resource.TotalInstallments,
		    "InstallmentAmount": resource.InstallmentAmount,
		    "UserId": resource.UserId,
		    "GeofenceId": resource.GeofenceId,
		    "CurrencyId": resource.CurrencyId,
		    "InsurancePremiumAmount": resource.InsurancePremiumAmount,
		    "AssetInsurancePremiumAmount": resource.AssetInsurancePremiumAmount,
		    "ApplicationStatusLkp": resource.ApplicationStatusLkp,
		    "CreatedBy": resource.CreatedBy,
		    "CreatedDate": resource.CreatedDate,
		    "LastUpdatedBy": resource.LastUpdatedBy,
		    "LastUpdatedDate": resource.LastUpdatedDate,
		    "ProcessInstanceId": resource.ProcessInstanceId
        }];
    }

    function unwrapLoanApplicationAttributes(resource){
        resource["TenantId"]= resource.TmXAccountApplication[0].TenantId,
	    resource["CompanyBranchId"]= resource.TmXAccountApplication[0].CompanyBranchId,
	    resource["LoanProductId"]= resource.TmXAccountApplication[0].ProductId,
	    resource["LoanApplicationId"]= resource.TmXAccountApplication[0].LoanApplicationId,
	    resource["LoanApplicationNumber"]= resource.TmXAccountApplication[0].LoanApplicationNumber,
	    resource["ClientReferenceNumber"]= resource.TmXAccountApplication[0].ClientReferenceNumber,
	    resource["LoanApplicationDate"]= resource.TmXAccountApplication[0].LoanApplicationDate,
	    resource["CustomerHouseholdId"]= resource.TmXAccountApplication[0].CustomerHouseholdId,
	    resource["RequestedLoanAmount"]= resource.TmXAccountApplication[0].RequestedLoanAmount,
	    resource["ApprovedLoanAmount"]= resource.TmXAccountApplication[0].ApprovedLoanAmount,
	    resource["TotalRecieiveableAmount"]= resource.TmXAccountApplication[0].TotalRecieiveableAmount,
	    resource["LoanDisbursementDate"]= resource.TmXAccountApplication[0].LoanDisbursementDate,
	    resource["LoanMaturityDate"]= resource.TmXAccountApplication[0].LoanMaturityDate,
	    resource["TotalInstallments"]= resource.TmXAccountApplication[0].TotalInstallments,
	    resource["InstallmentAmount"]= resource.TmXAccountApplication[0].InstallmentAmount,
	    resource["UserId"]= resource.TmXAccountApplication[0].UserId,
	    resource["GeofenceId"]= resource.TmXAccountApplication[0].GeofenceId,
	    resource["CurrencyId"]= resource.TmXAccountApplication[0].CurrencyId,
	    resource["InsurancePremiumAmount"]= resource.TmXAccountApplication[0].InsurancePremiumAmount,
	    resource["AssetInsurancePremiumAmount"]= resource.TmXAccountApplication[0].AssetInsurancePremiumAmount,
	    resource["ApplicationStatusLkp"]= resource.TmXAccountApplication[0].ApplicationStatusLkp,
	    resource["CreatedBy"]= resource.TmXAccountApplication[0].CreatedBy,
	    resource["CreatedDate"]= resource.TmXAccountApplication[0].CreatedDate,
	    resource["LastUpdatedBy"]= resource.TmXAccountApplication[0].LastUpdatedBy,
	    resource["LastUpdatedDate"]= resource.TmXAccountApplication[0].LastUpdatedDate,
	    resource["ProcessInstanceId"]= resource.TmXAccountApplication[0].ProcessInstanceId
    }


    var Page={
        id:1,
        title:"Create Financing",
        Fields:[
            {
                FieldLabel:"Financing Copy Source",
                type:"Text",
                FieldName:"FinanceCopySource",
                FieldTableName:"dummy",
                FieldSequence:1,
                IsDisabled:0,
                IsMandatory:0,
                FieldLookupType:"DUMMY",
            },
            {
                FieldLabel:"Version",
                type:"Text",
                FieldName:"version",
                FieldTableName:"dummy",
                FieldSequence:2,
                value:1,
                IsDisabled:1,
                IsMandatory:0,
                FieldLookupType:"DUMMY",
            },
            {
                FieldLabel:"Financing Name",
                type:"Text",
                FieldName:"FinanceName",
                FieldTableName:"dummy",
                FieldSequence:2,
                IsDisabled:0,
                IsMandatory:1,
                FieldLookupType:"DUMMY",
            },
            {
                FieldLabel:"Financing Status",
                type:"Text",
                FieldName:"FinancingStatus",
                FieldTableName:"dummy",
                FieldSequence:3,
                IsDisabled:1,
                value:"New",
                IsMandatory:0,
                FieldLookupType:"DUMMY",
            },
            {
                FieldLabel:"Financing Type Description",
                type:"Text",
                FieldName:"FinancingDescription",
                FieldTableName:"dummy",
                FieldSequence:3,
                IsDisabled:0,
                IsMandatory:0,
                FieldLookupType:"DUMMY",
            },
            {
                FieldLabel:"Financing Type",
                type:"Dropdown",
                FieldName:"FinancingType",
                FieldTableName:"dummy",
                FieldSequence:4,
                IsDisabled:0,
                IsMandatory:1,
                FieldLookupType:"SCREEN",
            },
            {
                FieldLabel:"Asset Technology Description",
                type:"text",
                FieldName:"AssetTechnologyDescription",
                FieldTableName:"dummy",
                FieldSequence:4,
                IsDisabled:0,
                IsMandatory:0,
                FieldLookupType:"SCREEN",
            },
            {
                FieldLabel:"Asset Technology",
                type:"Dropdown",
                FieldName:"AssetTechnology",
                FieldTableName:"dummy",
                FieldSequence:5,
                IsDisabled:0,
                IsMandatory:1,
                FieldLookupType:"SCREEN",
            },
            {
                FieldLabel:"Orignal Principal Balance",
                type:"Numeric",
                FieldName:"OrignalPrincipalBalance",
                FieldTableName:"dummy",
                FieldSequence:5,
                IsDisabled:0,
                IsMandatory:1,
                FieldLookupType:"SCREEN",
            },
            {
                FieldLabel:"Closing Date",
                type:"DateTime",
                FieldName:"Closing Date",
                FieldTableName:"dummy",
                FieldSequence:6,
                IsDisabled:0,
                IsMandatory:1,
                FieldLookupType:"SCREEN",
            },
            {
                FieldLabel:"Financing Maturity Date",
                type:"DateTime",
                FieldName:"FinancingMaturityDate",
                FieldTableName:"dummy",
                FieldSequence:7,
                IsDisabled:0,
                IsMandatory:1,
                FieldLookupType:"SCREEN",
            },
        ]
    }
})();

